import { z } from 'zod';
/** Catalogue repris du prototype ; les exploitants doivent valider ces types. */
export const TYPES_EQUIPEMENT = [
  { code: 'POSTE_SOURCE', libelle: 'Poste source HTB/HTA', domaine: 'ELECTRICITY' },
  { code: 'TRANSFO', libelle: 'Transformateur HTA/BT', domaine: 'ELECTRICITY' },
  { code: 'DEPART_HTA', libelle: 'Départ HTA', domaine: 'ELECTRICITY' },
  { code: 'GROUPE', libelle: 'Centrale / groupe électrogène', domaine: 'ELECTRICITY' },
  { code: 'ECLAIRAGE', libelle: 'Armoire d’éclairage public', domaine: 'ELECTRICITY' },
  { code: 'STATION_POMPAGE', libelle: 'Station de pompage', domaine: 'WATER' },
  { code: 'RESERVOIR', libelle: 'Réservoir / château d’eau', domaine: 'WATER' },
  { code: 'FORAGE', libelle: 'Forage', domaine: 'WATER' },
  { code: 'CANALISATION', libelle: 'Tronçon de canalisation', domaine: 'WATER' },
  { code: 'BORNE_FONTAINE', libelle: 'Borne-fontaine', domaine: 'WATER' },
] as const;
export const ETATS_EQUIPEMENT = {
  IN_SERVICE: 'En service',
  DEGRADED: 'Dégradé',
  OUT_OF_SERVICE: 'Hors service',
  MAINTENANCE: 'En maintenance',
  DECOMMISSIONED: 'Retiré du service',
};
export const schemaEquipement = z.object({
  code: z
    .string()
    .trim()
    .regex(/^[A-Z0-9-]{3,30}$/),
  nom: z.string().trim().min(3).max(150),
  type: z.enum(TYPES_EQUIPEMENT.map((t) => t.code)),
  province_id: z.string().uuid(),
  localisation: z.string().trim().min(2).max(250),
  latitude: z.number().min(-4).max(2.5),
  longitude: z.number().min(8).max(15),
  criticite: z.number().int().min(1).max(4).default(2),
  statut: z
    .enum(
      Object.keys(ETATS_EQUIPEMENT) as [
        keyof typeof ETATS_EQUIPEMENT,
        ...(keyof typeof ETATS_EQUIPEMENT)[],
      ],
    )
    .default('IN_SERVICE'),
  fabricant: z.string().trim().max(100).default(''),
  caracteristiques: z.string().trim().max(4000).default(''),
});
export const schemaModificationEquipement = schemaEquipement.extend({
  version: z.number().int().positive(),
  motif: z.string().trim().min(3).max(500),
});
export const schemaPlanMaintenance = z.object({
  equipement_id: z.string().uuid(),
  titre: z.string().trim().min(3).max(150),
  operations: z.string().trim().min(3).max(4000),
  frequence_jours: z.number().int().min(1).max(3650),
  prochaine_echeance: z.iso.date(),
});
export const schemaRealisationMaintenance = z.object({
  version: z.number().int().positive(),
  realise_le: z.iso.date(),
  notes: z.string().trim().min(3).max(4000),
});
export const schemaActivationMaintenance = z.object({
  version: z.number().int().positive(),
  actif: z.boolean(),
  motif: z.string().trim().min(3).max(500),
});
